import * as React from "react";
import { forwardRef, memo } from "react";

const SvgTriangleUpIcon = (props, ref) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M7.6 6.533a.5.5 0 0 1 .8 0l2 2.667a.5.5 0 0 1-.4.8H6a.5.5 0 0 1-.4-.8l2-2.667Z"
      fill="currentColor"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgTriangleUpIcon);
const Memo = memo(ForwardRef);
export default Memo;
